export default "__VITE_ASSET__kG$Qr1BE__"